import type { TouchEvent } from 'react';
import { ArrowLeft, Home, LocateFixed } from 'lucide-react';

interface KioskBottomBarProps {
  onHome: () => void;
  onBack: () => void;
  onCenter?: () => void;
  backLabel?: string;
  homeLabel?: string;
}

export const KioskBottomBar = ({
  onHome,
  onBack,
  onCenter,
  backLabel = 'VOLVER',
  homeLabel = 'INICIO',
}: KioskBottomBarProps) => {
  const handleTouch = (event: TouchEvent<HTMLButtonElement>, action: () => void) => {
    event.preventDefault();
    action();
  };

  return (
    <nav className="kiosk-bottom-bar" aria-label="Navegación del tótem">
      <button
        className="kiosk-bottom-bar-back"
        onClick={onBack}
        onTouchEnd={(event) => handleTouch(event, onBack)}
        type="button"
        aria-label={backLabel}
        title={backLabel}
      >
        <ArrowLeft />
      </button>

      {onCenter && (
        <button
          className="kiosk-bottom-bar-center"
          onClick={onCenter}
          onTouchEnd={(event) => handleTouch(event, onCenter)}
          type="button"
          title="Volver al encuadre inicial del mapa"
        >
          <LocateFixed aria-hidden="true" />
          Centrar
        </button>
      )}

      <button
        className="kiosk-bottom-bar-home"
        onClick={onHome}
        onTouchEnd={(event) => handleTouch(event, onHome)}
        type="button"
        aria-label={homeLabel}
        title={homeLabel}
      >
        <Home />
      </button>
    </nav>
  );
};
